import { useEffect } from 'react'

export const META_PIXEL_ID = '3558743824301066'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/** Indlæser Meta Pixel én gang og sender en PageView. */
export function useMetaPixel(pixelId: string = META_PIXEL_ID) {
  useEffect(() => {
    if (typeof window === 'undefined') return

    if (!window.fbq) {
      const fbq: Window['fbq'] = function (...args: unknown[]) {
        if (fbq!.callMethod) {
          fbq!.callMethod.apply(fbq, args)
        } else {
          fbq!.queue!.push(args)
        }
      } as NonNullable<Window['fbq']>

      window.fbq = fbq
      if (!window._fbq) window._fbq = fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      document.head.appendChild(script)

      const noscript = document.createElement('noscript')
      const pixelImage = document.createElement('img')
      pixelImage.height = 1
      pixelImage.width = 1
      pixelImage.style.display = 'none'
      pixelImage.alt = ''
      pixelImage.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
      noscript.appendChild(pixelImage)
      document.body.appendChild(noscript)
    }

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')
  }, [pixelId])
}

/** Sender et standard-event til Meta Pixel, hvis det er indlæst. */
export function trackPixelEvent(event: string, data?: Record<string, unknown>) {
  if (typeof window === 'undefined') return
  window.fbq?.('track', event, data)
}
